import * as React from 'react';

import { IKpiReportInputModel, IKpiReportModel } from './KpiReport';

import Html5ReportViewer from '../../../components/report/Html5ReportViewer';
import { ICollabReportViewProps } from '../collab-report/CollabReportController';

export function KpiReportRenderer<T extends IKpiReportModel, I extends IKpiReportInputModel>(
    props: ICollabReportViewProps<T, I>
) {
    if (!props.data.renderReport) return null;

    const [refreshReport, setRefreshReport] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (props.data.refreshToken && props.inputModel && !refreshReport) {
            setRefreshReport(true);
        }
    }, [props.data.refreshToken, props.inputModel]);

    return (
        <Html5ReportViewer
            offsetTop={100}
            onRenderComplete={() => {
                setRefreshReport(false);
            }}
            refreshReport={refreshReport}
            reportName="KpiReport.trdp"
            reportParameters={props.inputModel}
            scale={1.3}
        />
    );
}
